export { TenderContractDashboardSupplierAwardedComponent} from './tender-contract-dashboard-supplier-awarded.component';

